import { observable } from "mobx";

class VehicleChangeDuringValidityRequest {
  @observable
  licensePlate!: string;

  @observable
  countryId!: string;

  @observable
  emailAddress?: string;
}

export default class VehicleChangeDuringValidity extends VehicleChangeDuringValidityRequest {
  @observable
  _licensePlateConfirmation!: string;

  @observable
  _countryIdConfirmation!: string;

  @observable
  _originalLicensePlate!: string;

  @observable
  emailAddress?: string;

  @observable
  _agreement?: boolean;
}
